<template>
    <footer class="footer">
        <div class="container">
            <div class="footer__top">
                <div class="footer__column">
                    <span>Contact details</span>
                    <p>
                        Twentepoort West 15
                        <br />
                        7609RD, Almelo
                    </p>
                    <p>
                        <i class="mdi mdi-phone"></i>
                        Tel.: +31 (0)546 536 300
                        <br />
                        <i class="mdi mdi-email"></i>
                        E:
                        <a href="mailto:info@tecnotion.com">info@tecnotion.com</a>
                        -
                        <a href="mailto:sales@tecnotion.com">sales@tecnotion.com</a>
                    </p>
                </div>
                <div class="footer__column">
                    <span>Offices</span>
                    <ul>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-headquarters/">
                                Headquarters
                            </a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-china/">China</a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-dach/">Germany</a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-rep-of-korea/">
                                Korea
                            </a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-nw-europe/">
                                Netherlands
                            </a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-east-europe/">
                                Poland
                            </a>
                        </li>
                        <li>
                            <a href="https://www.tecnotion.com/location/tecnotion-usa/">
                                United States
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer__bottom">
                <span>
                    &copy; {{ new Date().getFullYear() }} Tecnotion BV. All rights reserved.
                </span>
                <ul class="footer__bottom__links">
                    <li>
                        <a href="https://www.tecnotion.com/privacy-statement" target="_blank">
                            Privacy statement
                        </a>
                    </li>
                    <li>
                        <a href="https://www.tecnotion.com/cookie-policy" target="_blank">
                            Cookie policy
                        </a>
                    </li>
                    <li>
                        <a href="https://www.tecnotion.com/terms-and-conditions" target="_blank">
                            Terms and conditions
                        </a>
                    </li>
                    <li>
                        <a href="https://www.tecnotion.com/content" target="_blank">
                            Terms of Content
                        </a>
                    </li>
                    <li>
                        <a href="https://www.tecnotion.com/imprint" target="_blank">
                            Imprint
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class TheFooter extends Vue {}

Vue.component('the-footer', TheFooter);
</script>
